import React from 'react';

/**
 * SensorStatusIndicator Component
 * Matches SensorPush web app UI with status bar and moving dot
 */

const SensorStatusIndicator = ({ status, type, showLabel = true, className = '', style = {} }) => {
  if (!status || status === 'UNKNOWN') {
    return (
      <div className={`status-indicator ${className}`} style={style}>
        {showLabel && <span className="status-label">CALCULATING</span>}
        <div className="status-bar-container">
          <div className="status-bar-bg"></div>
          <div className={`status-dot ${type} unknown`}></div>
        </div>
      </div>
    );
  }

  // Determine dot position based on status
  const getDotPosition = (status) => {
    switch (status) {
      case 'RISING':
        return '75%'; // Right side of bar
      case 'FALLING':
        return '25%'; // Left side of bar
      case 'STEADY':
      default:
        return '50%'; // Center of bar
    }
  };

  const dotPosition = getDotPosition(status);

  return (
    <div className={`status-indicator ${className}`} style={style}>
      {showLabel && <span className="status-label">{status}</span>}
      <div className="status-bar-container">
        <div className="status-bar-bg"></div>
        <div 
          className={`status-dot ${type} ${status.toLowerCase()}`}
          style={{ left: dotPosition }}
        ></div>
      </div>
    </div>
  );
};

export default SensorStatusIndicator;
